/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Official_EvidenceInputs */

const en_directory_agent_readiness_official_evidence = /** @type {(inputs: Directory_Agent_Readiness_Official_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official evidence`)
};

const zh_directory_agent_readiness_official_evidence = /** @type {(inputs: Directory_Agent_Readiness_Official_EvidenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方证据`)
};

/**
* | output |
* | --- |
* | "Official evidence" |
*
* @param {Directory_Agent_Readiness_Official_EvidenceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_official_evidence = /** @type {((inputs?: Directory_Agent_Readiness_Official_EvidenceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Official_EvidenceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_official_evidence(inputs)
	return zh_directory_agent_readiness_official_evidence(inputs)
});
export { directory_agent_readiness_official_evidence as "directory.agent_readiness.official_evidence" }